import { SxProps, Theme } from '@mui/material';

const queueContainer: SxProps<Theme> = {
  padding: 2,
  marginY: 2,
};

const textField: SxProps<Theme> = (theme) => ({
  backgroundColor: theme.palette.common.white,
  marginTop: 3,

  '&:first-of-type': {
    marginTop: 0,
  },

  '&:last-of-type': {
    marginBottom: 3,
  },
});

const cancelButton: SxProps<Theme> = {
  marginLeft: 1,
};

const styles = {
  queueContainer,
  textField,
  cancelButton,
};

export default styles;
